import React, { useState, useEffect  } from 'react'
// import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  // ListGroupItem,
  CustomInput,
  Input,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import Alert from 'react-s-alert';

// PaymentCard
const PaymentCard = (props) => {

  const [billingDetails, setBillingDetails] = useState({
    email: '',
    name: '',
  });
  let [processing, setProcessing] = useState(false)

  const stripe = useStripe();
  const elements = useElements();

  // // componentDidMount
  // useEffect(() => {
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);


  // createPaymentMethod
  let _createPaymentMethod = async () => {

    props.setLoading(true)

    let cardElement = elements.getElement(CardElement)

    let result = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    })
    if (result.error) {
      
      Alert.error(result.error, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      props.setLoading(false)

      return;
    }

    props.setLoading(false)

    // update payment method
    _updatePaymentMethod({
      paymentMethodId: result.paymentMethod.id,
    });
  }

  // _updatePaymentMethod
  let _updatePaymentMethod = ({paymentMethodId}) => {
    props.updatePaymentMethod(paymentMethodId)
  }

  return (
    <div style={{
      marginTop: 20,
      marginBottom: 20,
    }}>

      {props.editing === true ? (
        <div>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">
              <span>名前:</span>
              <br />
              <Input
                disabled={processing}
                type="text"
                style={{
                  width: '100%',
                }}
                name='billingName'
                onChange={(e) => {
                  setBillingDetails({...billingDetails, name: e.target.value});
                }}
                value={billingDetails.name}
                placeholder='' />
            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">
              <span>メールアドレス:</span>
              <br />
              <Input
                disabled={processing}
                type="text"
                style={{
                  width: '100%',
                }}
                name='billingEmail'
                onChange={(e) => {
                  setBillingDetails({...billingDetails, email: e.target.value});
                }}
                value={billingDetails.email}
                placeholder='' />
            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 30,
          }}>
            <Col md="12" xs="12">
              <span>カード情報:</span>
              <br />
              <div style={{
                padding:8,
                borderWidth: 1,
                borderColor: '#cccccc',
                borderStyle: 'solid',
                borderRadius: 4,
              }}>
                <CardElement options={{
                  disabled: processing,
                  hidePostalCode: true,
                  iconStyle: 'solid',
                  style: {
                    base: {
                      fontWeight: 500,
                      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                      fontSize: '22px',
                      fontSmoothing: 'antialiased',
                    },
                  },
                }}/>
              </div>
            </Col>
          </Row>


          {processing === true && (
            <div>
              <Row style={{
                marginTop: 20,
                marginBottom: 30,
              }}>
                <Col md="12" xs="12">

                  処理中です。

                </Col>
              </Row>
            </div>
          )}

          <Row style={{
            marginTop: 30,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">
              {processing === true ? (
                <span>
                  処理中です...
                </span>
              ) : (
                <Button
                  onClick={_createPaymentMethod}
                  color="primary"
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                  }}>
                    更新
                  </Button>
              )}

            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">
              ※ 決済はStripe社のテクノロジーによって安全に行われます。
            </Col>
          </Row>

        </div>
      ) : (
        <div>
          <Row>
            <Col md="3" xs="12">

              {props.item.brand && props.item.brand.toLowerCase() === "visa" && (
                <img src={require("../../../images/visa_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "american express" && (
                <img src={require("../../../images/americanexpress_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "diners club" && (
                <img src={require("../../../images/dinersclub_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "discover" && (
                <img src={require("../../../images/discover_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "jcb" && (
                <img src={require("../../../images/jcb_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "mastercard" && (
                <img src={require("../../../images/mastercard_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "unionpay" && (
                <img src={require("../../../images/unionpay_dark.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}
              {props.item.brand && props.item.brand.toLowerCase() === "unknown" && (
                <img src={require("../../../images/unkown_card.png")}
                  style={{
                    width: 100,
                    height: 60,
                }} alt="card" />
              )}

            </Col>
            <Col md="9" xs="12">

              {props.item.brand && props.item.last4 && (
                <span style={{
                  fontSize: 30,
                }}>
                  {props.item.brand}....{props.item.last4}
                </span>
              )}

            </Col>
          </Row>
        </div>
      )}

    </div>
  )
}

export default PaymentCard
